define('lib/controller/booking/BaseStep',['require','marionette'],function (require) {

	var Marionette = require('marionette');

	/**
	 * Base step class. You should inherit your booking steps classes from BaseStep.
	 * 
	 * @class BaseStep
	 */
	return Marionette.Object.extend({
	
		_step: '',
		_stepManager: null,
	    _bookingModel: null,
		_skipped: false,

	    /**
	     * Inits instance
	     */
	    initialize: function() {
	    	this._stepManager = this.getOption('stepManager');
	        this._bookingModel = this.getOption('bookingModel');
	    },

		/**
		 * Initializes step object
		 */
		initStep: function () {
		},
        
        /**
         *  clear previously added collection filters
         */
        clearCollectionFilters: function () {
        },

        /**
         * Triggers init event
         */
        triggerInit: function () {
            this.triggerStepEvent('init', [this]);
        },

		/**
		 * Returns true if step has view, else returns false.
		 * If step does not have view it must override processStep method
		 *
		 * @return {boolean}
		 */
		hasView: function () {
			return true;
		},

        /**
		 * Start processing step, calling before show, refresh view for each step
         */
		start: function () {
		},

		/**
		 * Process step without view
		 * In case it returns true then next step will be processed/shown before done of this step
		 *
		 * @return boolean
		 */
		processStep: function () {
		},

		/**
		 * Returns true if need clear content. This function calls before processStep.
		 *
		 * @return boolean
		 */
		clearContent: function () {
			return false;
		},

	    /**
	     * Returns step view
	     * 
	     * @return Marionette.View
	     */
	    getStepView: function () {
	    	var view = this.getView();
	    	if (view) {
	    		this.listenTo(view, 'before:show', this._beforeViewShow);
	    		this.listenTo(view, 'render', this._afterRenderView);
				this.listenTo(view, 'show', this._afterViewShow);
	    		
	    		return view;
	    	}
	    },
	    
	    /**
	     * Should return step view
	     * 
	     * @return Marionette.View
	     */
	    getView: function () {
	    	throw 'Please override getView method in step';
	    },

        /**
		 * In case controller tries to show the same step you can refresh view here
         */
		refreshView: function () {
		},

	    /**
	     * Validates step data and must return true if all data is valid for this step, else must return false.
	     * 
	     * @return Boolean
	     */
	    isValid: function () {
	    	return false;
	    },

		/**
		 * Returns true in case step is skipped (eg. only one provider can be selected, so we automaticaly select it)
		 *
		 * @return Boolean
		 */
		isStepSkipped: function () {
			return this._skipped;
		},

		/**
		 * Set is skipped flag
		 *
		 * @param Boolean flag
		 */
		setIsSkipped: function (flag) {
			this._skipped = flag;
		},

	    /**
	     * Updates booking info
	     */
	    updateInfo: function () {
	    },

	    /**
	     * Use this method when you want to finish current step and show next invalid step.
	     * Make sure that your <code>isValid</code> method will return true in this case,
	     * otherwise it will restart this step again.
	     */
	    done: function () {
	    	this.trigger('done');
	    },
	    
	    /**
	     * Calls before view shows
	     */
	    _beforeViewShow: function (view, region) {
	    	this.triggerStepEvent('before:show', [this, view, region]);
	    	this.beforeViewShow(view, region);
	    },
	    
	    /**
	     * Calls on render view
	     */
	    _afterRenderView: function (view, region) {
	    	this.triggerStepEvent('render', [this, view]);
	    	this.afterRenderView();
	    },

		/**
		 * Calls after show view
		 */
		_afterViewShow: function (view, region) {
			this.triggerStepEvent('show', [this, view]);
			this.afterViewShow(view, region);
		},

		/**
		 * You can add your logic here after view has been rendered
		 *
		 * @param Marionette.View view
         */
	    afterRenderView: function (view) {
	    },

        /**
         * You can add your logic here before render view
         *
         * @param Marionette.View view
         * @param Marionette.Region region
         */
	    beforeViewShow: function (view, region) {
	    },

		/**
		 * You can add your logic here after render view
		 *
		 * @param Marionette.View view
		 * @param Marionette.Region region
		 */
		afterViewShow: function (view, region) {
		},
	    
	    /**
	     * Triggers step manager events
	     * 
	     * @param String event
	     * @param Array args
	     */
	    triggerStepEvent: function (event, args) {
	    	this._stepManager.triggerMethod.apply(this._stepManager, ['step:' + event + ':' + this._step].concat(args));
	    	this._stepManager.triggerMethod.apply(this._stepManager, ['step:' + event, this._step].concat(args));
	    }
	
	});
	
});
